var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.427 12.604c-.464 0-.88.184-1.197.471l-4.358-2.536c.031-.14.055-.281.055-.428 0-.147-.024-.287-.055-.428l4.309-2.511c.33.305.764.495 1.246.495a1.83 1.83 0 001.834-1.834A1.83 1.83 0 0012.427 4a1.83 1.83 0 00-1.833 1.833c0 .147.024.288.055.428L6.341 8.773a1.83 1.83 0 00-3.08 1.338 1.83 1.83 0 003.08 1.338l4.35 2.543a1.72 1.72 0 00-.048.397c0 .984.8 1.784 1.784 1.784s1.785-.8 1.785-1.784-.8-1.785-1.785-1.785zm0-7.382c.337 0 .612.275.612.611a.613.613 0 01-.612.611.613.613 0 01-.61-.61c0-.337.274-.612.61-.612zm-7.333 5.5a.613.613 0 01-.611-.61c0-.337.275-.612.611-.612.336 0 .611.275.611.611a.613.613 0 01-.61.611zm7.333 4.29a.613.613 0 01-.61-.61c0-.337.274-.612.61-.612.337 0 .612.275.612.611a.613.613 0 01-.612.611z",
    fill: "#fff"
  })));
};

export default SvgShare;